module.exports = __webpack_public_path__ + "66a4daea4a8a80252aced45ca49b6e02.pdf";